/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ConciergeAuxMetric
 */
export interface ConciergeAuxMetric {
  /**
   *
   * @type {string}
   * @memberof ConciergeAuxMetric
   */
  name: string;
  /**
   *
   * @type {Array<{ [key: string]: any; }>}
   * @memberof ConciergeAuxMetric
   */
  values: Array<{ [key: string]: any }>;
}

/**
 * Check if a given object implements the ConciergeAuxMetric interface.
 */
export function instanceOfConciergeAuxMetric(value: object): value is ConciergeAuxMetric {
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('values' in value) || value['values'] === undefined) return false;
  return true;
}

export function ConciergeAuxMetricFromJSON(json: any): ConciergeAuxMetric {
  return ConciergeAuxMetricFromJSONTyped(json, false);
}

export function ConciergeAuxMetricFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConciergeAuxMetric {
  if (json == null) {
    return json;
  }
  return {
    name: json['name'],
    values: json['values'],
  };
}

export function ConciergeAuxMetricToJSON(value?: ConciergeAuxMetric | null): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
    values: value['values'],
  };
}
